import { Link } from "react-router-dom";
import { Leaf, Mail, Phone, MapPin } from "lucide-react";
import { CONTACT_INFO } from "@/constants/site";

const LEGAL_LINKS = [
    { label: "Mentions légales", to: "/mentions-legales" },
    { label: "Politique de confidentialité", to: "/politique-confidentialite" },
];

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="bg-rz-deep text-white pt-20 pb-10 px-6 md:px-12"
    >
        <div className="mx-auto max-w-[1400px]">
            <div className="flex flex-col gap-10 md:flex-row md:items-start md:gap-40 lg:gap-64 pb-16 border-b border-white/10">
                <div className="max-w-sm">
                    <div className="flex items-center gap-2.5 mb-6">
                        <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
                            <Leaf size={18} />
                        </span>
                        <span className="font-display text-lg font-extrabold tracking-tight">
                            ROZIER CONCEPT
                        </span>
                    </div>
                    <p className="text-white/60 text-base leading-relaxed">
                        Bâtiments agricoles et équestres 100% sur mesure. Écoconstruction,
                        bien-être animal et bâtiments solaires, conçus autour du vivant.
                    </p>
                </div>

                <div>
                    <p className="text-xs tracking-[0.2em] uppercase text-rz-sage mb-5">
                        Légal
                    </p>
                    <ul className="space-y-3">
                        {LEGAL_LINKS.map((link) => (
                            <li key={link.to}>
                                <Link
                                    to={link.to}
                                    data-testid={`footer-link-${link.to.replace("/", "")}`}
                                    className="text-white/70 hover:text-white transition-colors text-sm"
                                >
                                    {link.label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>

                <div>
                    <p className="text-xs tracking-[0.2em] uppercase text-rz-sage mb-5">
                        Contact
                    </p>
                    <ul className="space-y-4">
                        <li className="flex items-center gap-3 text-white/80 text-sm">
                            <Phone size={16} className="text-rz-sage shrink-0" /> {CONTACT_INFO.phone}
                        </li>
                        <li className="flex items-center gap-3 text-white/80 text-sm">
                            <Mail size={16} className="text-rz-sage shrink-0" /> {CONTACT_INFO.email}
                        </li>
                        <li className="flex items-center gap-3 text-white/80 text-sm">
                            <MapPin size={16} className="text-rz-sage shrink-0" /> {CONTACT_INFO.zone}
                        </li>
                    </ul>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-8">
                <p className="text-white/50 text-xs text-center md:text-left">
                    © {new Date().getFullYear()} ROZIER CONCEPT, agricole et haras. Tous droits réservés.
                </p>
                <a
                    href="https://axeris-labs.fr"
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-credit-link"
                    className="text-white/50 hover:text-white transition-colors text-xs"
                >
                    Site conçu et réalisé par Axeris Labs
                </a>
            </div>
        </div>
    </footer>
);
